<template>
  <div>
    <div class="marginCenter">
      <el-form :model="form.applyBasic" :rules="rules" label-position="top" label-width="200px" class="form marginTop30">
        <!-- 进修信息 -->
        <div class="marginBom30">
          <div class="fsize24 fcolor_black marginBom18">进修信息</div>
          <div class="content fsize22">
            进修报到一般在每月第2个工作日，具体以《进修报到通知单》为准。因报到、岗前培训需多部门协作，故请进修人员务必在进修报到日当天报到。
          </div>
        </div>
        <!-- 进修要求 -->
        <div class="marginBom30 title">
          <el-form-item prop="trainRequest" label="进修内容与目标" >
            <el-input class="marginTop24" type="textarea" :rows="2" :maxlength="500" show-word-limit placeholder="请输入内容" v-model="form.applyBasic.trainRequest">
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <el-form :model="trainForm" :rules="trainRules" label-position="left" class="form marginTop30" label-width="120px">
        <el-row>
          <el-col :span="8">
            <el-form-item prop="trainDirection" label="进修方向">
              <el-select v-model="trainForm.trainDirection" clearable placeholder="请选择" @change="trainDirectionChange">
                <el-option v-for="item in trainDirectionList" :key="item.trainDirectionId" :label="item.trainDirectionName" :value="item.trainDirectionId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="deptId" label="进修科室">
              <el-select v-model="trainForm.deptId" clearable placeholder="请选择">
                <el-option v-for="item in deptList" :key="item.deptId" :label="item.deptName" :value="item.deptId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
            <el-col :span="8">
            <el-form-item prop="beginDate" label="开始时间">
              <el-date-picker :picker-options="startDateOptions" v-model="trainForm.beginDate" format="yyyy-MM" value-format="yyyy-MM-dd" type="month" placeholder="选择月" @change="changeMonth">
              </el-date-picker>
            </el-form-item>
          </el-col>
            <el-col :span="8">
            <el-form-item prop="beginDate" label="结束时间">
              <el-date-picker :picker-options="endDateOptions" v-model="trainForm.endDate" type="month" value-format="yyyy-MM-dd" placeholder="选择月" @change="endChange">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="trainDuration" label="进修总时长">
               <el-input  disabled placeholder="自动计算" v-model="trainForm.trainDuration" :maxlength="3" onkeyup="value=value.replace(/[^\d]/g,'')">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="overflow staging marginBom30">
        <el-button class="fr blueBtn2 btn300" @click="staging" type="primary">保存此页信息</el-button>
      </div>
      <div class="footer flex-yCenter">
        <a class="a backIndex fcolor_blue2 fsize22" @click="goPage(2)">1</a>
        <a class="a backIndex active fcolor_blue2 fsize22" @click="goPage(3)">2</a>
        <a class="a backIndex fcolor_blue2 fsize22" @click="goPage(4)">3</a>
        <a class="a backIndex fcolor_blue2 fsize22" @click="goPage(4)">下一页</a>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getApplyStorage,
  setStorageNurseApplyInfo,
  systemDirectionList,
  nurseDirectionList
} from "@/utils/api";
import Modal from "@/views/components/modal.vue";
import dayjs from "dayjs";
export default {
  dicts: ["train_direction"],
  components: {
    Modal,
  },
  data() {
    return {
      form: {
        trainType: "",
        // 申请信息
        applyBasic: {},
        // 进修科室
        applyDeptList: [],
        // 附件
        applyAttList: [],
      },
      trainDirectionList: [],
      // 科室列表
      deptList: [],
      rules: {
        trainRequest: {
          required: true,
          trigger: "blur",
          message: "进修要求不能为空!",
        },
      },
      trainForm: {
        trainDirection: "",
        deptId: "",
        trainDuration: "",
        month: null,
      },
      trainRules: {
        trainDirection: {
          required: true,
          trigger: ["change"],
          message: "进修方向不能为空!",
        },
        deptId: {
          required: true,
          trigger: "change",
          message: "请选择进修科室!",
        },
        // trainDuration: {
        //   required: true,
        //   trigger: "change",
        //   message: "请选择进修总时长!",
        // },
      },
      trainDurationOptions: [],
      disDate:{
        maxMonth:0,
        minMonth:0
      }
    };
  },
  watch: {},

   async created() {
    this.form = this.$parent.nurseForm;
    console.log(this.form.applyBasic.post);
    await this.getDirectionList(this.form.applyBasic.post);
    // console.log(this.form.applyDeptList)
    if(this.form.applyDeptList.length > 0){
      let obj  =  this.trainDirectionList.find(item => item.trainDirectionId == this.form.applyDeptList[0].trainDirection)
      if(obj){
        this.disDate.minMonth = obj.minMonth
        this.disDate.maxMonth = obj.maxMonth
      }
      console.log(obj);
      // this.trainDirectionChange(this.form.applyDeptList[0].trainDirection)
      this._getDeptList(this.form.applyDeptList[0].trainDirection)
    }
    // 回显进修报到时间
    if (this.form.applyDeptList.length > 0) {
      this.trainForm = this.form.applyDeptList[0];
      if(this.trainForm.trainDuration==''){
        this.changeMonth()
      }
    }  
  },
  mounted() {},
  computed: {
  startDateOptions() {
    console.log(this.trainForm.endDate)
    const endDate = this.trainForm.endDate ? new Date(this.trainForm.endDate) : null;
    const currentDate = dayjs().endOf('month').endOf('day').toDate();
    console.log(currentDate)
    return {
      disabledDate: (time) => {
        if (time.getTime() <= currentDate.getTime()) {
            return true;
        }
        if (!endDate ) return false;
        const minDate = dayjs(endDate).startOf('month').subtract(this.disDate.maxMonth-1, 'month').toDate();
        const maxDate = dayjs(endDate).subtract(this.disDate.minMonth-1, 'month').toDate();
        return time.getTime() < minDate.getTime() || time.getTime() > maxDate.getTime();
      }
    };
  },
    endDateOptions() {
     const beginDate = this.trainForm.beginDate ? new Date(this.trainForm.beginDate) : null;
    const currentDate = dayjs().endOf('month').endOf('day').toDate();
      return {
        disabledDate: (time) => {
          if (time.getTime() <= currentDate.getTime()) {
            return true;
          }
          if (!beginDate ) return false;
          const minDate = dayjs(beginDate).add(this.disDate.minMonth-1, 'month').toDate();
           const maxDate = dayjs(beginDate).add(this.disDate.maxMonth-1, 'month').toDate()
          return time.getTime() < minDate.getTime() || time.getTime() > maxDate.getTime();
        }
      };
    },
  },

  methods: {
    // 获取限制日期
    trainDirectionChange(val){
      if(!this.form.applyBasic.post){
       return this.$message.error('请先选择职称')
      }
      let obj  =  this.trainDirectionList.find(item => item.trainDirectionId == val)
      if(obj){
        this.disDate.minMonth = obj.minMonth
        this.disDate.maxMonth = obj.maxMonth
      }
      console.log(obj)
      this.$set(this.trainForm, 'trainDuration', '')
      this.$set(this.trainForm, 'deptId', '')
      this.$set(this.trainForm, 'endDate', '')
      this.$set(this.trainForm, 'beginDate', '')
      this.$set(this.trainForm, 'month', '')
      this._getDeptList(val)
    },
    // 获取进修方向
   async  getDirectionList(jobTitle) {
    const res = await systemDirectionList({
        jobTitle,
        pageSize:9999
      })
      this.trainDirectionList = res.rows
    },
    _getDeptList(trainDirection) {
      // 获取科室列表
      nurseDirectionList({trainDirection,pageSize:9999}).then((res) => {
        this.deptList = res.rows;
      }).catch((err) => {
        console.log(err);
      });
    },
    // 获取进修开始时间和结束时间
    changeMonth(e) {
      if(this.trainForm.endDate && this.trainForm.beginDate) {
        const monthDifference = dayjs(this.trainForm.endDate).diff(dayjs(this.trainForm.beginDate), 'month')+1;
        this.$set(this.trainForm, 'trainDuration', monthDifference)
        if(monthDifference < 0){
          this.$nextTick(() => {
           this.$set(this.trainForm, 'endDate', '')
           this.$set(this.trainForm, 'trainDuration', '')
          })
          this.$message.error(`结束时间应大于开始时间`)
        }
      }else{
        this.$set(this.trainForm, 'trainDuration', '')
      }
    },
    endChange(e) {
       this.changeMonth(e)
       this.trainForm.endDate  = dayjs(e).endOf('month').format('YYYY-MM-DD')
    },
       async goPage(val){ 
            await this.staging()
            this.$parent.active = val
        },
    // 保存此页信息
    staging() {
      let form = JSON.parse(JSON.stringify(this.trainForm));
      this.form.applyDeptList[0] = form;
      setStorageNurseApplyInfo(this.form).then((res) => {
        if (res.code == 200) {
          this.$message.success("暂存信息成功");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.marginCenter {
  margin-bottom: 50px;
}
::v-deep .title .el-form-item__label {
  font-size: 22px;
  color: #333;
  padding: 0;
}
// ::v-deep .el-form-item__label {
//   width: 120px;
// }

::v-deep .el-form-item__content {
  flex-grow: 1;
}

.el-button--primary {
  padding: 0;
}

.backIndex:hover {
  cursor: pointer;
}

.formTitle {
  margin: 50px 0px 30px 240px;
}

.step {
  margin-bottom: 50px;
}

::v-deep .el-input {
  width: 220px;
}
::v-deep .el-textarea__inner {
  height: 95px;
  font-size: 18px;
}
// ::v-deep.form {
//   margin-bottom: 47px;
//   overflow: hidden;

// }
.footer {
  justify-content: flex-end;
  .a {
    display: inline-block;
    width: 40px;
    line-height: 36px;
    text-align: center;
    border-radius: 5px;
    height: 40px;
    color: #333;
    border: #999999 solid 2px;
    margin-left: 30px;

    &:hover {
      border-color: #2d53c8;
    }
  }

  & > .a:last-child {
    width: 110px;
  }

  & > .active {
    border-color: #2d53c8;
  }
}
</style>
